module.exports = __webpack_public_path__ + "img/Caelum.e0215a18.png";